<!--  -->
<template>
  <div>
    <ul class="lit03">
      <li v-for="item in devicenav" :key="item.title">
        <div class="cont_r_b04">
          <div class="cont_r_b05">
            <img :src="item.img" width="158" height="109">
          </div>
          <div class="cont_r_b06">
            <div class="cont_r_b07">
              <p></p>
            </div>
            <div class="cont_r_b09">
              <p></p>
              <p>
                <span style="font-family:&quot;color:black;">
                  <strong>
                    <u>{{item.title}}</u>
                  </strong>
                </span>
              </p>
              <p>
                <span style="font-family:&quot;color:black;">
                  <span></span>
                </span>
                <span style="font-family:&quot;color:black;">
                  <br>
                </span>
              </p>
              <p style="font-family:&quot;color:black;" v-html="item.word"></p>
              <p></p>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      devicenav: [
        {
          title: "成套设备",
          word: "铝杆连铸连轧生产线<br />铜管生产线<br />钢筋生产线",
          img: require("../../../assets/img/common/home7.jpg")
        },
        {
          title: "有色金属加工设备",
          word:
            "高速盘拉机组<br />水平复绕机组<br />行星轧机<br />多辊轧机<br />联合拉拔精整机组<br />挤压机机组<br />罩式退火炉<br />连续退火炉",
          img: require("../../../assets/img/common/home8.jpg")
        },
        {
          title: "挤塑注塑设备",
          word: "挤出机<br />挤出模具<br />注塑模具<br />机筒螺杆",
          img: require("../../../assets/img/common/home9.jpg")
        },
        {
          title: "黑色金属加工设备",
          word: "多辊轧钢机<br />连续钢坯铸造机组",
          img: require("../../../assets/img/common/home10.jpg")
        }
      ]
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/devicesy.vue